<app-gtm-script [publicGtmId]="publicGtmId" />
<router-outlet (window:resize)="onResize()"></router-outlet>
